export default __webpack_public_path__ + "static/media/bw-executive-function-tutorial-pop-up-step-2.8cef65e0.svg";